import { render, staticRenderFns } from "./TipoProdutoList.vue?vue&type=template&id=7336005c"
import script from "./TipoProdutoList.vue?vue&type=script&lang=js"
export * from "./TipoProdutoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports